"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonVariant = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var react_tippy_1 = require("react-tippy");
var index_1 = __importDefault(require("../Icon/index"));
var ButtonVariant;
(function (ButtonVariant) {
    ButtonVariant[ButtonVariant["Normal"] = 0] = "Normal";
    ButtonVariant[ButtonVariant["Active"] = 1] = "Active";
})(ButtonVariant = exports.ButtonVariant || (exports.ButtonVariant = {}));
var button = function (props) {
    var disabled = props.disabled, icon = props.icon, children = props.children, variant = props.variant, tooltip = props.tooltip, tooltipClassName = props.tooltipClassName, openTooltip = props.openTooltip, className = props.className, rest = __rest(props, ["disabled", "icon", "children", "variant", "tooltip", "tooltipClassName", "openTooltip", "className"]);
    var cn = classnames_1.default("respectkit__button", className, {
        only_icon: children === undefined,
        with_tooltip: tooltip !== undefined,
        active: variant === ButtonVariant.Active,
        disabled: disabled,
        with_icon: icon != null && children !== undefined,
    });
    var iconItem = null;
    if (icon != null) {
        iconItem = react_1.default.createElement(index_1.default, { icon: icon });
    }
    var data = null;
    if (children) {
        data = react_1.default.createElement("span", null, children);
    }
    else {
        data = react_1.default.createElement("span", { className: "empty_text" }, "\u00A0"); // Don't remove this read warning before
    }
    var btnData = (react_1.default.createElement("button", __assign({ className: cn }, rest, { disabled: disabled }),
        iconItem,
        data));
    if (tooltip) {
        return (react_1.default.createElement(react_tippy_1.Tooltip, { title: tooltip, trigger: openTooltip ? "manual" : "mouseenter", open: openTooltip ? true : undefined, arrow: true, animation: "shift", sticky: true, stickyDuration: 0, style: { display: "inline-block" }, className: classnames_1.default("respectkit__button_tooltip", tooltipClassName) }, btnData));
    }
    else {
        return btnData;
    }
};
exports.default = button;
//# sourceMappingURL=index.js.map